import axios from "axios";
import config from "./config";

export const fetchSecretCode = () => {
  return axios.get("/associate-software-token/fetch-secret-code", config);
};
